import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicNavbar from "../components/PublicNavbar";
import HomeImageCarousel from "../components/HomeImageCarousel";
import NewsAndUpdateCarousel from "../components/NewsAndUpdateCarousel";
import FacilityCarousel from "../components/FacilityCarousel";
import FacebookPosts from "../components/FacebookPosts";
import Rates from "../pages/Rates";
import Location from "../pages/Location";
import CourtRules from "../pages/CourtRules";
import Shop from "../pages/Shop";
import { BACKEND_BASE as CENTRALIZED_BACKEND_BASE, API_URL as CENTRALIZED_API } from "../lib/api";

// Social Media Carousel Component (modern card-style)
const SocialMediaCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const timeoutRef = useRef(null);

  // Embed the Facebook Page plugin for the club page
  // We'll build the iframe src dynamically so `width`/`height` query params are responsive.
  const PAGE_HREF = "https://www.facebook.com/camsurpickleball";
  const FB_COMMON_PARAMS =
    "tabs=timeline&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false";
  const getFbSrc = (w, h) =>
    `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(
      PAGE_HREF
    )}&${FB_COMMON_PARAMS}&width=${w}&height=${h}`;

  const socialPosts = [
    {
      id: 1,
      type: "facebook",
      title: "Camsur Pickleball — Facebook Page",
    },
  ];

  useEffect(() => {
    // show loader briefly on mount
    setIsLoading(true);
    timeoutRef.current = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timeoutRef.current);
  }, []);

  // No external embed scripts required for the Facebook Page iframe

  const navigate = (next) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsLoading(true);
    timeoutRef.current = setTimeout(() => {
      setActiveIndex((i) =>
        next
          ? (i + 1) % socialPosts.length
          : (i - 1 + socialPosts.length) % socialPosts.length
      );
      setIsLoading(false);
    }, 350);
  };

  // Responsive behavior: observe available width and scale iframe crop accordingly
  const iframeContainerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // useEffect(() => {
  //   const updateWidth = () => {
  //     if (iframeContainerRef.current) {
  //       setContainerWidth(iframeContainerRef.current.clientWidth || 0);
  //     }
  //   };

  //   updateWidth();

  //   let ro;
  //   if (typeof ResizeObserver !== "undefined") {
  //     ro = new ResizeObserver(() => updateWidth());
  //     if (iframeContainerRef.current) ro.observe(iframeContainerRef.current);
  //   }

  //   // Also listen to window resize events to ensure updates across browsers
  //   // (some environments may not trigger ResizeObserver on container size change).
  //   window.addEventListener("resize", updateWidth);

  //   return () => {
  //     if (ro && iframeContainerRef.current) ro.disconnect();
  //     window.removeEventListener("resize", updateWidth);
  //   };
  // }, []);
  useEffect(() => {
    const containerEl = iframeContainerRef.current;

    const updateWidth = () => {
      if (containerEl) {
        setContainerWidth(containerEl.clientWidth || 0);
      }
    };

    updateWidth();

    let ro;
    if (typeof ResizeObserver !== "undefined" && containerEl) {
      ro = new ResizeObserver(updateWidth);
      ro.observe(containerEl);
    }

    window.addEventListener("resize", updateWidth);

    return () => {
      if (ro) ro.disconnect();
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  // Derived sizes (scale cropping based on available width)
  const BASE_MAX_WIDTH = 500;
  const effectiveWidth =
    containerWidth > 0
      ? Math.min(BASE_MAX_WIDTH, containerWidth)
      : BASE_MAX_WIDTH;
  const cropPx = Math.round(40 * (effectiveWidth / BASE_MAX_WIDTH));
  const extraHeight = Math.round(100 * (effectiveWidth / BASE_MAX_WIDTH));
  const maskHeight = Math.max(
    6,
    Math.round(25 * (effectiveWidth / BASE_MAX_WIDTH))
  );

  // Compute responsive width/height for Facebook plugin (preserve original aspect ratio)
  const DEFAULT_ASPECT = 700 / 500; // original height/width from previous params
  const fbWidth = Math.max(200, Math.round(effectiveWidth));
  const fbHeight = Math.max(300, Math.round(effectiveWidth * DEFAULT_ASPECT));
  const computedFbSrc = getFbSrc(fbWidth, fbHeight);

  return (
    <div className="w-full">
      <div className="relative mx-auto max-w-xl">
        {/* Card */}
        <div className="relative rounded-3xl bg-gradient-to-br from-white via-slate-50 to-white shadow-2xl ring-1 ring-slate-200 overflow-hidden">
          {/* Platform badge */}
          {/* <div className="absolute left-6 top-6 z-20 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-sm font-semibold text-slate-700 shadow"> 
            <img src="/assets/FB.png" alt="fb" className="h-4 w-4 object-contain" />
            Facebook
          </div> */}

          {/* Nav Buttons */}
          {/* <button
            aria-label="Previous post"
            onClick={() => navigate(false)}
            className="absolute left-4 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/80 p-2 shadow hover:scale-105 transition"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="#0f172a"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <button
            aria-label="Next post"
            onClick={() => navigate(true)}
            className="absolute right-4 top-1/2 z-20 -translate-y-1/2 rounded-full bg-white/80 p-2 shadow hover:scale-105 transition"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 6L15 12L9 18"
                stroke="#0f172a"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button> */}

          {/* Content area */}
          <div className="h-[420px] md:h-[560px] lg:h-[720px] flex items-center justify-center bg-[#f5f6f7]">
            <div className="relative w-full h-full flex items-center justify-center">
              {/* iframe container with smooth fade */}
              <div
                className={`absolute -mb-[25px] md:-mb-[20px] lg:-mb-[165px] -mt-[45px] inset-0 flex items-center justify-center transition-opacity duration-500 ${
                  isLoading ? "opacity-0" : "opacity-100"
                }`}
              >
                {/*
                  Wrap iframe in a viewport with `overflow: hidden` and a negative translate on the
                  iframe to crop the remaining small header. Adjust `cropPx` if header height changes.
                */}
                <div
                  ref={iframeContainerRef}
                  style={{
                    width: "100%",
                    maxWidth: effectiveWidth,
                    height: "calc(90% - 48px)",
                    borderRadius: 16,
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                  }}
                >
                  {/* Overlay mask to hide the Facebook plugin top header without shifting iframe content */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: maskHeight,
                      background: "#f5f6f7",
                      zIndex: 3,
                      pointerEvents: "none",
                      borderTopLeftRadius: 16,
                      borderTopRightRadius: 16,
                    }}
                  />
                  <iframe
                    key={computedFbSrc}
                    title={socialPosts[activeIndex].title}
                    src={computedFbSrc}
                    className=""
                    // set iframe to the computed Facebook plugin size and add extraHeight
                    style={{
                      border: 0,
                      width: `${fbWidth}px`,
                      maxWidth: "100%",
                      height: `${fbHeight + extraHeight}px`,
                      display: "block",
                      margin: 0,
                      transform: `translateY(-${cropPx}px)`,
                      boxSizing: "border-box",
                    }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen={true}
                    loading="lazy"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  />
                </div>
              </div>

              {/* Blurred loader overlay */}
              {isLoading && (
                <div className="absolute inset-0 z-30 flex flex-col items-center justify-center gap-3 bg-white/70 backdrop-blur-sm">
                  <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#1f6fa2] border-t-transparent" />
                  <div className="text-sm font-medium text-slate-700">
                    Loading
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Footer: title + indicators */}
          <div className="relative z-10 flex items-center justify-between gap-4 border-t border-slate-200 bg-slate-200 px-6 py-4">
            <div>
              <div className="text-sm font-semibold text-slate-800">
                {socialPosts[activeIndex].title}
              </div>
              <div className="text-xs text-slate-500">
                Community highlights and updates
              </div>
            </div>

            <div className="flex items-center gap-2">
              {socialPosts.map((p, idx) => (
                <button
                  key={p.id}
                  onClick={() => {
                    setActiveIndex(idx);
                    setIsLoading(true);
                    timeoutRef.current = setTimeout(
                      () => setIsLoading(false),
                      350
                    );
                  }}
                  aria-label={`Go to ${p.type} post ${idx + 1}`}
                  className={`h-2.5 w-8 rounded-full transition-all duration-300 ${
                    idx === activeIndex
                      ? "bg-gradient-to-r from-[#1f6fa2] to-[#1763a1] shadow"
                      : "bg-white hover:scale-110"
                  }`}
                  title={`${p.type.charAt(0).toUpperCase() + p.type.slice(1)} ${
                    idx + 1
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const scheduleItems = [
  {
    day: "15",
    month: "Jan",
    time: "1pm - 5pm",
    title: "Novice Tournament",
    subtitle: "at HEA Pickleball Court",
  },
  {
    day: "16",
    month: "Jan",
    time: "8am - 11am",
    title: "The Dink Minor League Pickleball -",
    subtitle: "Maiden Tournament",
  },
  {
    day: "15",
    month: "Jan",
    time: "1pm - 5pm",
    title: "Novice Tournament",
    subtitle: "at HEA Pickleball Court",
  },
];

const newsItems = [
  {
    date: "OCT 08, 2025",
    title: "Pickleball in the Philippines: here, there, and not going anywhere",
    image: "/assets/2.png",
    alt: "Players competing in a match",
  },
  {
    date: "SEP 21, 2025",
    title: "Community open play brings record turnout",
    image: "/assets/3.png",
    alt: "Outdoor pickleball courts with players",
  },
  {
    date: "AUG 14, 2025",
    title: "Club members celebrate new courts opening",
    image: "/assets/4.png",
    alt: "Club members posing together",
  },
];

const FALLBACK_GALLERY_ITEMS = [
  { src: `${process.env.PUBLIC_URL}/assets/2.png`, alt: "Players enjoying a match" },
  { src: `${process.env.PUBLIC_URL}/assets/3.png`, alt: "Outdoor pickleball courts" },
  { src: `${process.env.PUBLIC_URL}/assets/4.png`, alt: "Club members posing together" },
];

// Use centralized API config for consistent URL handling
const BACKEND_BASE = CENTRALIZED_BACKEND_BASE;
const API = CENTRALIZED_API;

const getWebSocketUrl = () => {
  const wsBase = BACKEND_BASE.replace(/^http/i, "ws");
  return `${wsBase}/api/ws`;
};

const formatCurrency = (amount) => {
  return `₱${Number(amount).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const FALLBACK_ADDON_ITEMS = [
  {
    name: "Paddle Rental",
    price: "₱50.00",
    available_quantity: 10,
    image: `${process.env.PUBLIC_URL}/assets/x.png`,
  },
  {
    name: "Ball Rental",
    price: "₱25.00",
    available_quantity: 20,
    image: `${process.env.PUBLIC_URL}/assets/z.png`,
  },
  {
    name: "Shoe Rental",
    price: "₱100.00",
    available_quantity: 5,
    image: `${process.env.PUBLIC_URL}/assets/c.png`,
  },
];

// Fallback facility items
const FALLBACK_FACILITY_ITEMS = [
  { src: `${process.env.PUBLIC_URL}/assets/f3.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f4.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f5.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f6.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f7.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f8.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f9.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f10.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f11.jpg`, alt: "Camsur Pickleball facility" },
  { src: `${process.env.PUBLIC_URL}/assets/f12.jpg`, alt: "Camsur Pickleball facility" },
];

const LandingPage = () => {
  const [galleryItems, setGalleryItems] = useState(FALLBACK_GALLERY_ITEMS);
  const [facilityItems, setFacilityItems] = useState(FALLBACK_FACILITY_ITEMS);
  const [addonItems, setAddonItems] = useState(
    FALLBACK_ADDON_ITEMS
  );
  const [addonLoading, setAddonLoading] = useState(true);
  const [addonIndex, setAddonIndex] = useState(0);
  const [addonPerView, setAddonPerView] = useState(1);

  useEffect(() => {
    let cancelled = false;

    const fetchGallery = async () => {
      try {
        const response = await fetch(`${API}/gallery`);
        if (!response.ok) return;

        const data = await response.json();
        const mapped = Array.isArray(data)
          ? data
              .filter((item) => item?.image || item?.image_file_id)
              .filter((item) => item.category !== 'Facilities') // Exclude Facilities category from gallery
              .map((item) => {
                // Use image_file_id to construct the correct URL with BACKEND_BASE
                // This ensures the image URL points to the correct backend server
                let imageSrc = item.image;
                if (item.image_file_id) {
                  imageSrc = `${API}/gallery/images/${item.image_file_id}`;
                } else if (item.image && !item.image.startsWith('http')) {
                  // If image is a relative path, prepend the backend base
                  imageSrc = `${BACKEND_BASE}${item.image.startsWith('/') ? '' : '/'}${item.image}`;
                }
                return {
                  src: imageSrc,
                  alt: item.title || item.category || "Gallery image",
                  date: item.date || null,
                };
              })
          : [];

        if (!cancelled && mapped.length > 0) {
          setGalleryItems(mapped);
        }
      } catch (error) {
        console.error("Failed to load gallery:", error);
      }
    };

    fetchGallery();
    return () => {
      cancelled = true;
    };
  }, []);

  // Fetch facility items from gallery API (Facilities category)
  useEffect(() => {
    let cancelled = false;

    const fetchFacilities = async () => {
      try {
        const response = await fetch(`${API}/gallery?category=Facilities`);
        if (!response.ok) return;

        const data = await response.json();
        const mapped = Array.isArray(data)
          ? data
              .filter((item) => item?.image || item?.image_file_id)
              .map((item) => {
                let imageSrc = item.image;
                if (item.image_file_id) {
                  imageSrc = `${API}/gallery/images/${item.image_file_id}`;
                } else if (item.image && !item.image.startsWith('http')) {
                  imageSrc = `${BACKEND_BASE}${item.image.startsWith('/') ? '' : '/'}${item.image}`;
                }
                return {
                  src: imageSrc,
                  hdSrc: imageSrc, // HD version uses same URL (full resolution from CMS)
                  alt: item.title || "Camsur Pickleball facility",
                  title: item.title || "",
                  description: item.description || "",
                };
              })
          : [];

        if (!cancelled && mapped.length > 0) {
          setFacilityItems(mapped);
        }
      } catch (error) {
        console.error("Failed to load facilities:", error);
      }
    };

    fetchFacilities();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchAddons = async () => {
      try {
        const response = await fetch(`${API}/addons`);
        if (!response.ok) return;

        const data = await response.json();
        const active = Array.isArray(data)
          ? data.filter((item) => item?.is_active !== false)
          : [];

        if (!cancelled && active.length > 0) {
          setAddonItems(active);
        }
      } catch (error) {
        // Keep fallback items on error
        console.error("Failed to load add-ons:", error);
      } finally {
        if (!cancelled) setAddonLoading(false);
      }
    };

    fetchAddons();

    // Realtime updates via WebSocket (auto-reconnect).
    let ws;
    let reconnectTimer;
    let reconnectDelayMs = 2000;

    const connect = () => {
      ws = new WebSocket(getWebSocketUrl());

      ws.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
          if (!msg || typeof msg !== "object") return;

          // Listen for pos_item (add-ons) events
          if (msg.type === "pos_item_created" && msg.item?.item_id) {
            const created = msg.item;
            if (created?.is_active === false) return;
            setAddonItems((prev) => {
              if (prev.some((e) => e.item_id === created.item_id))
                return prev;
              return [created, ...prev];
            });
            return;
          }

          if (msg.type === "pos_item_updated" && msg.item?.item_id) {
            const updated = msg.item;
            setAddonItems((prev) => {
              const next = prev.map((e) =>
                e.item_id === updated.item_id ? updated : e
              );
              return next.filter((e) => e?.is_active !== false);
            });
            return;
          }

          if (msg.type === "pos_item_deleted" && msg.item_id) {
            const id = msg.item_id;
            setAddonItems((prev) =>
              prev.filter((e) => e.item_id !== id)
            );
          }
        } catch {
          // ignore malformed messages
        }
      };

      ws.onopen = () => {
        reconnectDelayMs = 2000;
      };

      ws.onclose = () => {
        if (reconnectTimer) clearTimeout(reconnectTimer);
        reconnectTimer = setTimeout(() => {
          reconnectDelayMs = Math.min(reconnectDelayMs * 2, 30000);
          connect();
        }, reconnectDelayMs);
      };

      ws.onerror = () => {
        try {
          ws.close();
        } catch {
          /* ignore */
        }
      };
    };

    connect();

    return () => {
      cancelled = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      try {
        ws?.close();
      } catch {
        /* ignore */
      }
    };
  }, []);

  useEffect(() => {
    const updatePerView = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setAddonPerView(3);
      } else if (width >= 768) {
        setAddonPerView(2);
      } else {
        setAddonPerView(1);
      }
    };

    updatePerView();
    window.addEventListener("resize", updatePerView);
    return () => window.removeEventListener("resize", updatePerView);
  }, []);

  useEffect(() => {
    setAddonIndex((idx) =>
      Math.min(idx, Math.max(0, addonItems.length - addonPerView))
    );
  }, [addonPerView, addonItems.length]);

  const maxAddonIndex = Math.max(
    0,
    addonItems.length - addonPerView
  );

  const slideAddon = (direction) => {
    setAddonIndex((prev) => {
      const step = 1;
      if (direction === "next") {
        const next = prev + step;
        return next > maxAddonIndex ? 0 : next;
      }
      const next = prev - step;
      return next < 0 ? maxAddonIndex : next;
    });
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-white text-gray-900 font-avenir">
      {/* Hero */}
      <header className="relative" id="home">
        <PublicNavbar />

        <div className="relative h-screen w-full overflow-hidden">
          {/* Desktop / Large screens */}
          <div
            className="absolute left-0 top-0 hidden h-full w-full bg-no-repeat lg:block"
            style={{
              backgroundImage: "url('/newassets/bg.png')",
              backgroundSize: "100% 100%"
            }}
          />

          {/* Mobile / Tablet */}
          <div
            className="absolute left-0 top-0 block h-full w-full bg-no-repeat lg:hidden"
            style={{
              backgroundImage: "url('/newassets/bg.png')",
              backgroundSize: "100% 100%"
            }}
          />

          <div className="absolute inset-0" />
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
            <img
              src="/newassets/Logo.png"
              alt="Camsur Pickleball Club"
              className="w-50 drop-shadow-[0_0_30px_rgba(255,255,255,0.53)] w-52 md:w-64 lg:w-[28rem] xl:w-[30rem] mb-4"
            />

            {/* <div className="relative pt-10 mt-16 sm:mt-18 md:mt-20 group overflow-hidden">
              <Link
                to="/book/:venueId"
                className="
                  relative flex items-center justify-center uppercase font-avenir font-bold text-black
                  bg-[#d4881d] hover:bg-[#d26a00]
                  transition-all duration-300 rounded-full

                  text-sm sm:text-base md:text-xl xl:text-2xl
                  px-8 py-4 md:px-10 md:py-6 xl:px-16 xl:py-8
                "
              >
                <span className="z-50 font-avenir coiny-regular titan-one-regular text-white">
                  Book A Court
                </span>

                <img
                  src="/assets/art-paddle.png"
                  alt="Paddle Icon"
                  className="
                    absolute top-1/2 -translate-y-1/3 pointer-events-none
                    right-3 sm:right-4 md:right-6 xl:right-6

                    h-14 w-10 md:h-20 md:w-16 xl:h-28 xl:w-20

                    rotate-12 opacity-50
                    transition-all duration-400
                    group-hover:rotate-0
                  "
                />
              </Link>
            </div> */}

            <div className="relative pt-10 mt-16 sm:mt-18 md:mt-20 group">
              {/* THREE ICONS image positioned above the button */}
              <img
                src="/newassets/THREE ICONS.png"
                alt="icons"
                className="absolute -top-20 left-1/2 -translate-x-1/2 w-56 md:w-72 lg:w-80 z-30 pointer-events-none"
              />

              <Link
                to="/book/venue_camsur"
                className="relative flex items-center justify-center uppercase font-avenir font-bold text-white bg-[#194e7f] rounded-full overflow-visible z-20 px-10 py-4 md:px-14 md:py-5 lg:px-16 lg:py-6"
                aria-label="Book a court"
                style={{
                  transform: "scaleX(-1)",
                }}
              >

                {/* Shimmer Overlay */}
                <span
                  className="pointer-events-none absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:animate-shimmer z-10"
                ></span>

                {/* Button Text - flip back so text remains readable (in normal flow) */}
                <span
                  className="relative z-20 drop-shadow-md text-lg md:text-2xl lg:text-3xl whitespace-nowrap"
                  style={{ transform: "scaleX(-1)" }}
                >
                  Book A Court
                </span>
                {/* Optional paddle icon (kept mirrored by container) */}
                {/* <img
                  src="/assets/art-paddle.png"
                  alt="Paddle Icon"
                  className="absolute pointer-events-none transition-all duration-500 ease-out top-1/2 -translate-y-1/2 left-6 md:left-8 lg:left-10 h-20 w-14 md:h-28 md:w-20 lg:h-36 lg:w-24 opacity-30 rotate-[25deg] scale-90 group-hover:opacity-100 group-hover:rotate-0 group-hover:scale-110 z-20"
                /> */}
              </Link>

              {/* decorative green base strip to mimic the original image (inset slightly so it appears as an outline) */}
              <span className="absolute h-10 md:h-9 bg-[#c7e44a] rounded-b-full z-0" style={{ bottom: '-4px', left: '4px', right: '4px' }} />
            </div>
          </div>
        </div>
      </header>

      {/* Upcoming Schedule */}
      {/* <section className="bg-white" id="events">
        <div className="w-full bg-[#f08c1a] py-3 text-center text-xl font-semibold text-white">Upcoming Schedule</div>
        <div className="mx-auto max-w-6xl px-4 pb-2 pt-6 sm:px-8">
          <div className="flex items-center justify-center gap-2 bg-white pb-6 pt-3">
            {[0, 1, 2].map((dot) => (
              <span
                key={dot}
                className={`h-2.5 w-2.5 rounded-full border border-[#f08c1a] ${dot === 1 ? 'bg-[#f08c1a]' : 'bg-white'}`}
              />
            ))}
          </div>
          <div className="grid gap-6 md:grid-cols-3">
            {scheduleItems.map((item, idx) => (
              <article
                key={`${item.title}-${idx}`}
                className="flex items-start gap-5 rounded-[34px] border-2 border-orange-400 bg-white px-6 py-7 shadow-sm"
              >
                <div className="flex shrink-0 flex-col overflow-hidden rounded-full bg-[#f08c1a] text-white">
                  <div className="px-4 pt-3 text-center text-2xl font-bold leading-none">{item.day}</div>
                  <div className="mx-3 mt-2 h-px bg-white/80" />
                  <div className="px-4 pb-3 text-center text-sm font-semibold leading-none">{item.month}</div>
                </div>
                <div className="min-w-0 pt-1">
                  <div className="text-sm font-semibold text-[#d26a00]">{item.time}</div>
                  <div className="mt-2 space-y-1 text-left text-[15px] font-semibold text-gray-900">
                    <p className="leading-snug">{item.title}</p>
                    {item.subtitle && <p className="leading-snug">{item.subtitle}</p>}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section> */}

{/* News and Updates */}
<section
  id="whats-new"
  className="py-10 relative"
  style={{
    backgroundImage: "url('/newassets/White BG.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }}
>
  <div className="mx-auto max-w-7xl gap-1  px-2 relative z-10 bg-gradient-to-b from-sky-200/70 to-sky-300/50">
    {/* Facebook Posts */}
    <FacebookPosts />
  </div>
       {/* Gallery */}
<section
  id="gallery"
  className="py-10"
>
          <div className="mx-auto px-4" id="gallery">
          <HomeImageCarousel images={galleryItems} />
        </div>
        </section>
</section>



      {/* Our Facility */}
      <section className="bg-white py-12 relative" id="facility">
        <div className="mx-auto max-w-6xl px-4 relative z-10">
          <FacilityCarousel images={facilityItems} />
        </div>
        
      </section>

      <section id="rates">
        <Rates />
      </section>

      {/* Add-ons Section */}
      {/* <section className="bg-white py-14" id="addons">
        <div className="mx-auto max-w-6xl px-4">
          <h2 className="mb-8 text-center text-3xl font-bold text-[#f08c1a]">
            Add-ons
          </h2>

          <div className="mb-6 flex items-center justify-between">
            <h3 className="text-xl font-bold text-[#f08c1a]">
              Available Add-ons
            </h3>
          </div>

          <div className="relative flex items-center gap-4">
            <button
              onClick={() => slideAddon("prev")}
              className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#f08c1a] text-2xl text-white shadow-lg transition duration-200 hover:bg-[#d26a00]"
              aria-label="Previous add-on"
            >
              ‹
            </button>

            <div className="flex-1 overflow-hidden">
              <div
                className="flex gap-4 transition-transform duration-500 ease-in-out py-4 px-4"
                style={{
                  transform: `translateX(-${
                    addonIndex * (100 / addonPerView)
                  }%)`,
                }}
              >
                {addonItems.map((item) => (
                  <div
                    key={item.item_id || item.name}
                    className="shrink-0"
                    style={{
                      width: `calc(${100 / addonPerView}% - ${
                        ((addonPerView - 1) * 16) / addonPerView
                      }px)`,
                    }}
                  >
                    <div className="rounded-3xl border-4 border-[#f08c1a] bg-white p-6 text-center shadow-lg transition-all duration-300 hover:bg-orange-50 hover:border-[#d26a00] hover:shadow-xl hover:scale-[1.02]">
                      <div className="mb-4 flex h-48 items-center justify-center overflow-hidden rounded-2xl bg-white">
                        <img
                          src={item.image || 'https://images.pexels.com/photos/17299531/pexels-photo-17299531.jpeg'}
                          alt={item.name}
                          className="h-full w-full object-contain"
                          onError={(e) => { e.target.src = 'https://images.pexels.com/photos/17299531/pexels-photo-17299531.jpeg'; }}
                        />
                      </div>
                      <h4 className="mb-3 text-sm font-bold text-gray-900">
                        {item.name}
                      </h4>
                      <p className="text-lg font-bold text-[#f08c1a]">
                        {typeof item.price === "number"
                          ? formatCurrency(item.price)
                          : item.price ||
                            formatCurrency(
                              item.price_per_hour || item.price_per_day || 0
                            )}
                      </p>
                      <p className="mt-1 text-sm font-semibold text-gray-700">
                        {item.category === 'Services' ? 'Service' : `Available: ${Number(item.available_quantity ?? item.stock ?? 0)}`}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={() => slideAddon("next")}
              className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#f08c1a] text-2xl text-white shadow-lg transition duration-200 hover:bg-[#d26a00]"
              aria-label="Next add-on"
            >
              ›
            </button>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm font-bold">
            <button
              onClick={() => slideAddon("prev")}
              className="flex h-8 w-8 items-center justify-center rounded border-2 border-[#f08c1a] bg-white text-[#f08c1a] transition duration-200 hover:bg-[#f08c1a] hover:text-white"
            >
              ‹
            </button>
            {(() => {
              const totalPages = maxAddonIndex + 1;
              const currentPage = addonIndex + 1; // 1-based
              const pages = [];

              // Always show first page
              if (totalPages > 0) {
                pages.push(1);
              }

              // Calculate range around current page
              const start = Math.max(2, currentPage - 1);
              const end = Math.min(totalPages - 1, currentPage + 1);

              // Add ellipsis if there's a gap after first
              if (start > 2) {
                pages.push("...");
              }

              // Add pages around current
              for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) {
                  pages.push(i);
                }
              }

              // Add ellipsis if there's a gap before last
              if (end < totalPages - 1) {
                pages.push("...");
              }

              // Always show last page if more than 1 page
              if (totalPages > 1 && !pages.includes(totalPages)) {
                pages.push(totalPages);
              }

              return pages.map((page, idx) => {
                if (page === "...") {
                  return (
                    <span
                      key={`ellipsis-${idx}`}
                      className="px-1 text-[#f08c1a]"
                    >
                      ...
                    </span>
                  );
                }
                const isActive = page === currentPage;
                return (
                  <button
                    key={page}
                    onClick={() => setAddonIndex(page - 1)}
                    className={`flex h-8 w-8 items-center justify-center rounded border-2 transition duration-200 ${
                      isActive
                        ? "border-[#f08c1a] bg-[#f08c1a] text-white"
                        : "border-[#f08c1a] bg-white text-[#f08c1a] hover:bg-[#f08c1a] hover:text-white"
                    }`}
                  >
                    {page}
                  </button>
                );
              });
            })()}
            <button
              onClick={() => slideAddon("next")}
              className="flex h-8 w-8 items-center justify-center rounded border-2 border-[#f08c1a] bg-white text-[#f08c1a] transition duration-200 hover:bg-[#f08c1a] hover:text-white"
            >
              ›
            </button>
          </div>
        </div>
      </section> */}
      
      <section id="addons">
        <Shop embedded={true} />
      </section>

      <section id="court-rules">
        <CourtRules />
      </section>

      <section id="location">
        <Location />
      </section>

      {/* Footer */}
      <footer 
        className="relative w-full text-white pt-16 overflow-hidden bg-cover bg-[90%_50%] lg:bg-[100%_50%]" 
        style={{ 
          backgroundImage: "url('/newassets/55.png')", 
          backgroundRepeat: 'no-repeat'
        }}
      >

        <div className="max-w-7xl mx-auto px-6 pb-12 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 items-start">
            
            {/* Column 1: Logo */}
            <div className="flex justify-center md:justify-start">
              <img
                src="/assets/logo.png"
                alt="Camsur Pickleball Logo"
                className="h-40 md:h-56 w-auto drop-shadow-2xl"
              />
            </div>

            {/* Column 2: Navigation Links */}
            <div className="flex flex-col space-y-3 text-center md:text-left">
              {[
                { label: 'HOME', id: 'home' },
                { label: "WHAT'S NEW", id: 'whats-new' },
                { label: 'GALLERY', id: 'whats-new' },
                { label: 'FACILITY', id: 'facility' },
                { label: 'RATES', id: 'rates' },
                { label: 'SHOP', id: 'addons' },
                { label: 'COURT RULES', id: 'court-rules' },
                { label: 'LOCATION', id: 'location' }
              ].map((item) => (
                <button
                  key={item.label}
                  onClick={() => {
                    const element = document.getElementById(item.id);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                  }}
                  className="font-bold text-sm hover:text-[#004a80] transition-colors text-left"
                >
                  {item.label}
                </button>
              ))}
            </div>

            {/* Column 3: Membership & Socials */}
            <div className="space-y-8 text-center md:text-left">
              <div className="space-y-4">
                <h4 className="font-black text-lg">Membership</h4>
                <div className="flex flex-col space-y-3 font-bold text-sm">
                  <Link to="/login" className="hover:text-[#004a80] transition-colors">Login</Link>
                  <Link  className="hover:text-[#004a80] transition-colors">Download Our App</Link>
                  <Link  className="hover:text-[#004a80] transition-colors">Privacy Policy</Link>
                </div>
              </div>
            </div>

            {/* Column 4: Contact & Legal */}
            <div className="space-y-6">
              <div>
                <h4 className="font-black text-lg text-center md:text-left mb-2">Legal</h4>
                <Link to="/login" className="block font-bold text-sm hover:text-[#004a80] text-center md:text-left">Member Login</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Orange Copyright Bar */}
        <div className="bg-[#ff8a00] py-4 text-center text-white font-bold text-sm tracking-wider">
          2025 Camsur Pickleball. All Rights Reserved.
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
